import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import Underdogs from './Basketball/Hero/Images/The Underdogs.jpg';
import Ringerz from './Basketball/Hero/Images/Ringerz.png';
import Wildwest from './Basketball/Hero/Images/WildWest Ballers.jpg';
import Doodles from './Basketball/Hero/Images/Just Doodles.jpg';
import Ace from './Basketball/Hero/Images/TEAM ACE LOGO.png';
import Mavericks from './Basketball/Hero/Images/Travis Mavericks Logo.png'
import Kpako from './Basketball/Hero/Images/Kpako BC.jpg'


function Teams() {
  return (
    <Div>
        <TeamContain>
                <br/>
                <h1>2023/2024 TEAMS</h1>
                <br/>
                <Link to="/doodles" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Doodles} alt='img'/>
                    <h1>Just Doodles</h1>
                    <h3>Owner: Prof.</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/kpako" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Kpako} alt='img'/>
                    <h1>Kpako BC</h1>
                    <h3>Owner: Kpako Wears</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/ringerz" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Ringerz} alt='img'/>
                    <h1>Ringerz</h1>
                    <h3>Owner: Lase & Co.</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/ace" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Ace} alt='img'/>
                    <h1>Ace</h1>
                    <h3>Owner: Elon Etherprince</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/underdogs" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Underdogs} alt='img'/>
                    <h1>The Underdogs</h1>
                    <h3>Owner: San J</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/ace" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Mavericks} alt='img'/>
                    <h1>Travis Mavericks</h1>
                    <h3>Owner: Ugopreneur</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
                <Link to="/ace" style={{color:"white", textDecoration:"none"}}>
                  <Contain>
                    <img src={Wildwest} alt='img'/>
                    <h1>WildWest Ballers</h1>
                    <h3>Owner: WildWest Xchange</h3>
                  </Contain>
                </Link>
                <br/><br/><br/>
        </TeamContain>
    </Div>

  )
}

export default Teams

const Div = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
`

const TeamContain = styled.div`
width: 90%;
display: flex;
flex-direction: column;
justify-content: space-around;
align-items: center;
`

const Contain = styled.div`
width: 500px;
height: 500px;
display: flex;
flex-direction: column;
justify-content: space-around;
align-items: center;
background: whitesmoke;
box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

h1 {
  color: maroon;
  border: outset;
}
h3 {
  color: darkorange;
  border: outset;
}
@media screen and (max-width: 750px) {
    width: 300px;
    height: 200px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 3px 12px 0 rgba(0, 0, 0, 0.19);   
}

img {
    height: 40%;
    width: 60%;
}
`